import React from 'react';
import styled from 'styled-components';
import AresSpecialBodyContainer from './AresSpecialBodyContainer';
import JournalEntrySource from '../../../JESource/JournalEntrySource/JournalEntrySource';

function JournalEntrySourceComponentBody(props) {
	const {
		showGuidance,
		guidanceFilter,
		bodyContent,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView
	} = props;

	return (
		<StyledJournalEntrySourceComponentBody className="StyledJournalEntrySourceComponentBody">
			<AresSpecialBodyContainer
				showGuidance={showGuidance}
				guidanceFilter={guidanceFilter}
				bodyContent={bodyContent}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={bodyId}
				updateBodyOptions={updateBodyOptions}
				getBodiesBySectionId={getBodiesBySectionId}
				isSnapshotView={isSnapshotView}
			>
				<JournalEntrySource />
			</AresSpecialBodyContainer>
		</StyledJournalEntrySourceComponentBody>
	);
}

export default JournalEntrySourceComponentBody;

const StyledJournalEntrySourceComponentBody = styled.section``;
